import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { SvgIconProps } from "@mui/material/SvgIcon";

type JobAttributeProps = {
  IconComponent: React.ComponentType<SvgIconProps>;
  text?: string;
};

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.up("sm")]: {
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1),
  },
}));

export const JobAttribute: React.FC<JobAttributeProps> = ({
  IconComponent,
  text,
}) => {
  if (!text) return null;

  return (
    <Row>
      <IconComponent
        sx={{
          fontSize: { xs: 18, sm: 22 },
          color: "#0f1941",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        color="#0f1941"
        sx={{
          fontSize: { xs: "0.813rem", sm: "0.875rem" },
          lineHeight: { xs: 1.3, sm: 1.4 },
        }}
      >
        {text}
      </Typography>
    </Row>
  );
};
